// extracted by mini-css-extract-plugin
export default {"container":"Rastreio_container__DJs5u","containerDados":"Rastreio_containerDados__qV1U7"};